// Kiểu dữ liệu cột trong mẫu bảng lương
export default {
  Amount: 2,
  Text: 3,
  Rate: 1,
  Coefficient: 0,
};
